const SHARED_OBSERVER = new IntersectionObserver(async (entries, observer) => {
    for (const entry of entries) {
        const el = entry.target;
        if (!el.dataset.src)
            continue;
        if (entry.isIntersecting) {
            el.style.backgroundImage = `url('${el.dataset.src}')`;
        }
        else {
            el.style.backgroundImage = "none";
        }
    }
}, { root: null, rootMargin: "0px", threshold: 0 });
/**
 * A Vue.js directive to load a background image only if the element is visible.
 */
export const lazyBgImg = {
    inserted: (el, binding, vnode) => {
        SHARED_OBSERVER.observe(el);
    },
    unbind: (el, binding, vnode) => {
        SHARED_OBSERVER.unobserve(el);
    },
};
//# sourceMappingURL=index.js.map